import { render, staticRenderFns } from "./Cabecera2.vue?vue&type=template&id=9968b5e4&"
import script from "./Cabecera2.vue?vue&type=script&lang=js&"
export * from "./Cabecera2.vue?vue&type=script&lang=js&"
import style0 from "./Cabecera2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports